import { useCallback, useState } from 'react'

export const useProductImageHovered = () => {
	const [isProductImageHovered, setIsProductImageHovered] =
		useState<boolean>(false)

	const handleMouseEnter = useCallback(() => {
		setIsProductImageHovered(true)
	}, [])

	const handleMouseLeave = useCallback(() => {
		setIsProductImageHovered(false)
	}, [])

	return { isProductImageHovered, handleMouseEnter, handleMouseLeave }
}
